
        var result = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./Tree.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./packages/tree/Tree.scss
// module id = 30
// module chunks = 1 2